import React, {useLayoutEffect, useRef, useState} from "react";

/**
 * Замена ResponsiveContainer из recharts 1.8.
 *
 * Штатный ResponsiveContainer запоминает ширину при монтировании и не
 * пересчитывает её при изменении размера окна или ширины колонки: график
 * остаётся прежнего размера и вылезает за пределы контейнера. Здесь размеры
 * уходят прямо в график пропсами width/height, а ширина контейнера
 * отслеживается тремя независимыми способами — ResizeObserver, событие resize
 * окна и замер после каждого рендера, — потому что в части окружений
 * (встроенные webview, вкладка без отрисовки) ResizeObserver молчит.
 */
export const ChartBox = ({aspect = 1, minHeight = 160, children}) => {
    const ref = useRef(null)
    const [width, setWidth] = useState(0)

    const measure = () => {
        const el = ref.current
        if (!el) return
        const next = Math.round(el.getBoundingClientRect().width)
        setWidth(prev => (prev === next ? prev : next))
    }

    // без списка зависимостей: замер повторяется после каждого рендера
    useLayoutEffect(measure)

    useLayoutEffect(() => {
        const el = ref.current
        if (!el) return

        window.addEventListener('resize', measure)

        let observer
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(measure)
            observer.observe(el)
        }

        return () => {
            window.removeEventListener('resize', measure)
            if (observer) observer.disconnect()
        }
    }, [])

    const height = Math.max(minHeight, Math.round(width / aspect))

    return <div ref={ref} style={{width: '100%', overflow: 'hidden'}}>
        {width > 0 && React.cloneElement(React.Children.only(children), {width, height})}
    </div>
}

export default ChartBox
